import React, { useState, useEffect } from "react";
import { Formik, Form } from "formik";
import { jwtDecode } from 'jwt-decode';
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import SelectLang from "./SelectLang";
import * as Yup from "yup";
import { FaRegHandPointRight } from "react-icons/fa";
import axiosConn from "config/axiosConn";
import SideBar from "./SideBar";
import { useDispatch } from "react-redux";
import { changeLang, selectedVoice } from "../../redux/langSlice";
import Helper from "../../helper/Common_Helper"
import { FaBarsStaggered } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { userLoggedIn, userLoggedOut } from "../../redux/auth/authSlice";

function CreateTheme() {
  const [openSidebar, setOpenSidebar] = useState(false);
  const [role, setRole] = useState('');
  const [initialValues, setInitialValues] = useState({ udise_id: "" });
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [checkbox1, setCheckbox1] = useState(false);
  const dispatch = useDispatch();
  // const [langSelected, setLangSelected] = useState(localStorage.getItem('langCode') || 'en-IN');
  const userData = useSelector(state => state.auth.user);
  const [langSelected, setLangSelected] = useState(userData?.lang);
  useEffect(() => {
    // let token = localStorage.getItem('token');
    if (userData) {
      setLangSelected(userData?.lang);
      // let auth = jwtDecode(token);
      setInitialValues({ ...initialValues, udise_id: userData?.udise_id });
      setRole(userData?.role);
      // getLanguageFunction({ udise_id: userData?.udise_id })
    }
  }, [userData]);

  // const getLanguageFunction = async (data) => {
  //   try {
  //     const response = await axiosConn('post', 'get-language', data)
  //     if (response.data.status === 'success') {
  //       let lang = response.data.result.lang;
  //       let voice = response.data.result.voice;
  //       setLangSelected(lang);
  //       dispatch(changeLang(lang));
  //       dispatch(selectedVoice(voice));
  //       localStorage.setItem('langCode', lang);
  //       localStorage.setItem('voice', voice);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }


  const confirmLanguageSelection = async() => {
    try {
      const result=await axiosConn('post', 'update-language', { lang: selectedLanguage.langCode, udise_id: initialValues.udise_id, voice: selectedLanguage.voice })
      setIsModalOpen(false);
      setLangSelected(selectedLanguage.langCode);
      dispatch(changeLang(selectedLanguage.langCode));
      dispatch(selectedVoice(selectedLanguage.voice));
      // dispatch()
      console.log(result,"result");
      dispatch(
        userLoggedIn({
          // accessToken: result.data.accessToken,
          user: result.data.result,
        })
      );
      // toast.info(`Please note the default language for the dashboard will be English. The selected language ${selectedLanguage} will be applied only to theme and subtheme.`);
    } catch (error) {
      console.log(error);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleCheckboxChange = (setter) => () => setter(prev => !prev);
  const handleSidebar = () => {
    setOpenSidebar(!openSidebar);
  }
  return (
    <Formik enableReinitialize initialValues={initialValues} validationSchema={Yup.object().shape({})}
      onSubmit={(values, { setSubmitting }) => { setSubmitting(false); }} >

      {({ values, errors, touched, isSubmitting, setFieldValue }) => (
        <Form className="bg-blue-900">
          <section className="scholdashbrdSec">
            <div className="desktopView" style={{ marginTop: 70, textAlign: "end" }}>
              <Link className="button green bars" onClick={handleSidebar}><FaBarsStaggered size={20} /></Link>
            </div>
            <div className={`sidebar ${openSidebar ? "open" : "hideen"}`}>
              <SideBar langSelected={langSelected} index={6} role={role} />
            </div>
            <div className="schlDashbrdRgt slctedLangDivNew">
              <div className="row">
                <div className="col-md-12 slctedLangDivNewIn">
                  <div className="card-user pageContainer">
                    <div class="card-header pgHederSpceArnd">
                      <h5 class="card-title text-center">Selected Language: {Helper.languages.find(language => language.langCode === langSelected)?.name}</h5>
                    </div>
                    <p className="text-center">Change your language</p>
                    <br />
                    <SelectLang setIsModalOpen={setIsModalOpen} setSelectedLanguage={setSelectedLanguage} langSelected={Helper.languages.find(language => language.langCode === langSelected)?.name} /><br /><br />
                  </div>
                </div>
                <div className="noteTextDiv">
                  <p><FaRegHandPointRight /> <span>Note:</span> Please note the default language for the dashboard will remain English. </p>
                </div>
              </div>
            </div>
          </section>

          <Modal show={isModalOpen}
            onHide={() => { setIsModalOpen(false); setCheckbox1(false) }} dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title" >

            <Modal.Header closeButton>
              <Modal.Title id="example-custom-modal-styling-title">
                Confirm
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="inviteTeamCnt">
                <div className="row">
                  <h2>Confirm Language Selection</h2>
                  <p>Are you sure you want to select <i>{selectedLanguage.name}</i> as the default language for the school and all faculty logins?</p>
                  <div className="form-check">
                    <input type="checkbox" className="form-check-input" id="checkbox1"
                      checked={checkbox1} onChange={handleCheckboxChange(setCheckbox1)} />
                    <label className="form-check-label" htmlFor="checkbox1">I Agree</label>
                  </div>

                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button type="button"
                className="btn btn-primary button green float-left btnconfirmbtn"
                onClick={confirmLanguageSelection} disabled={!checkbox1} >
                Confirm
              </button>
              <button onClick={closeModal} className="btn btn-primary button green float-left btncanclebtn">
                Cancel
              </button>
            </Modal.Footer>
          </Modal>
        </Form>
      )}
    </Formik>
  );
}

export default CreateTheme;
